import React, { FC, useRef } from "react";
import type { HomeWorldProps } from "@/types";
import { ContentManager } from "../content-manager";
import { Tags } from "../tags";
import { useInView } from "@/hooks/reveal-in-view";
import { HomeWorldMap } from "./world-map";
import SplitTextAnimation from "../split-text-animation";

export const HomeWorld: FC<HomeWorldProps> = ({
  title,
  description,
  text,
  tags,
}) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "0px 0px 25% 0px" });

  return (
    <section className="homeWorld">
      <div className="wrapper">
        <SplitTextAnimation
          htmlElement={
            <h2 className="homeWorld--title" ref={ref}>
              {title}
            </h2>
          }
          isInView={isInView}
        />
        <ContentManager
          content={description}
          className="homeWorld--description"
          style={{
            transform: isInView ? "none" : `translateY(20px)`,
            opacity: isInView ? 1 : 0,
            transition: "all 0.5s cubic-bezier(0.17, 0.55, 0.55, 1)",
          }}
        />
      </div>
      <div className="wrapper wrapper_lg">
        <HomeWorldMap />
      </div>
      <div className="wrapper">
        <ContentManager content={text} className="homeWorld--text" />
      </div>
      <Tags tags={tags} className="homeWorld--tags" />
    </section>
  );
};
